type BrandLogoVariant = "symbol" | "lockup" | "mark";

interface BrandLogoProps {
  variant?: BrandLogoVariant;
  className?: string;
  priority?: boolean;
}

const brandAssets: Record<BrandLogoVariant, string> = {
  symbol: "/brand/nsc-symbol-2026.webp",
  lockup: "/brand/nsc-horizontal-2026.webp",
  mark: "/brand/nsc-symbol-2026.webp",
};

export function BrandLogo({ variant = "symbol", className = "", priority = false }: BrandLogoProps) {
  return (
    <img
      src={brandAssets[variant]}
      alt=""
      aria-hidden="true"
      className={`brand-logo block object-contain ${className}`}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
    />
  );
}
